import React from "react";
import ReactDOM from "react-dom";
import App from "App";
import { registerWorker, registerPeriodicNewsCheck } from "./registerWorker";

ReactDOM.render(<App />, document.getElementById("root"));

registerWorker();
registerPeriodicNewsCheck();
